import React, { useState, useRef, useEffect, useContext } from "react";
import { useParams, Navigate } from "react-router-dom";
import {
  Typography,
  TextField,
  Button,
  Paper,
  Box,
  CircularProgress,
} from "@mui/material";
import { AuthContext } from "../../AuthContext";
import Cookies from "js-cookie";
import AiFormUpdateProdWrapper from "../AiFormUpdateProdWrapper";
import FrontendView from "./buttonApp/buttonAppFrontendView/FrontendView";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function ClientValidation() {
  const [aiFormData, setAiFormData] = useState({});
  const { client_url } = useParams();
  const [verification, setVerification] = useState(
    Cookies.get(client_url) ? Cookies.get(client_url) : false
  );
  const [loading, setLoading] = useState(true);
  const { clientverify } = useContext(AuthContext);
  const [user, setUser] = useState({});
  const [projecttpye, setProjecttype] = useState("");
  const [error, setError] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoLoading, setLogoLoading] = useState(true);
  const [brandColor, setBrandColor] = useState("#000");
  const [showKeyboard, setShowKeyboard] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }

    const getColor = async () => {
      try {
        const response = await fetch(`/auth/aiform/frontend/${client_url}`);
        const data = await response.json();

        if (!response.ok) {
          setError(data.message);
        } else {
          const UserData = data?.user;
          setUser(data?.user);
          let projecttpyee = data?.projecttpye;

          setProjecttype(projecttpyee);

          if (UserData?._id) {
            fetchLogo(UserData._id);
          } else {
            setLogoLoading(false);
          }

          if (projecttpyee === "menu_system" && UserData?.bypass_menu_login) {
            setVerification(true);
          }

          if (projecttpyee === "ai_human") {
            if (UserData?.bypass_menu_login) {
              setVerification(true);
            }
          }

          setError("");
        }
      } catch (error) {
        console.error("Error fetching AI form data:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchLogo = async (clientId) => {
      console.log(clientId);
      try {
        const response = await fetch(
          `/api/login-customizations/getLogoImage/${clientId}`
        );
        const data = await response.json();

        if (response.ok && data.logo) {
          setLogoUrl(data.logo);
        }

        if (response.ok) {
          setBrandColor(data.brandColor);
        }

        console.log("brandColor", data);
      } catch (error) {
        console.error("Error fetching logo:", error);
      } finally {
        setLogoLoading(false);
      }
    };

    console.log("brandColor", brandColor);

    getColor();
  }, [client_url]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`/auth/aiform/frontend/clientverify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          client_url,
          client_pin: aiFormData.client_pin,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("Server error");
        return;
      } else {
        if (data.status) {
          setVerification(!verification);
          clientverify(client_url, data.status);
        } else {
          alert(data.message);
        }
      }
    } catch (error) {
      console.error("Error in newSession:", error);
    }
  };

  const handleManualInputChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, "").slice(0, 4);
    setAiFormData({
      ...aiFormData,
      client_pin: numericValue,
    });
  };

  const handleKeyPress = (value) => {
    const currentPin = aiFormData.client_pin || "";

    if (value === "⌫") {
      setAiFormData({
        ...aiFormData,
        client_pin: currentPin.slice(0, -1),
      });
    } else if (value === "Enter") {
      handleSubmit({ preventDefault: () => {} });
    } else {
      if (currentPin.length < 4 && /^\d$/.test(value)) {
        setAiFormData({
          ...aiFormData,
          client_pin: currentPin + value,
        });
      }
    }
  };

  const keys = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["⌫", "0", "Enter"],
  ];

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error) {
    return <Navigate to="/not-authorized" />;
  }

  if (verification) {
    if (projecttpye === "menu_system") {
      return <FrontendView />;
    }

    if (projecttpye === "ai_human") {
      return <AiFormUpdateProdWrapper />;
    }
  } else {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: 2, sm: 3, md: 4 },
          // backgroundColor: "#f5f5f5",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: {
              xs: "100%",
              sm: "80%",
              md: "60%",
              lg: "50%",
              xl: "50%",
            },
            margin: "3vw auto",
          }}
        >
          {/* Logo Section */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: { xs: 3, sm: 4, md: 5 },
              padding: { xs: 2, sm: 3 },
            }}
          >
            {logoLoading ? (
              <CircularProgress />
            ) : (
              <img
                src={logoUrl || "/vendors/images/login-page-img.png"}
                alt="Holomedia"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  objectFit: "contain",
                  width: "100vw",
                }}
              />
            )}
          </Box>

          {/* Verification Card */}
          <Paper
            elevation={8}
            sx={{
              padding: { xs: 3, sm: 4, md: "3vw", lg: "2.5vw", xl: "2vw" },
              borderRadius: { xs: 3, md: "1vw" },
              backgroundColor: "#ffffff",
              boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: { xs: 2, sm: 3, md: "2vw" },
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: 50,
                    sm: 60,
                    md: "5vw",
                    lg: "4.5vw",
                    xl: "4.5vw",
                  },
                  height: {
                    xs: 50,
                    sm: 60,
                    md: "5vw",
                    lg: "4.5vw",
                    xl: "4.5vw",
                  },
                  minWidth: "50px",
                  minHeight: "50px",
                  // maxWidth: "100px",
                  // maxHeight: "100px",
                  borderRadius: "50%",
                  backgroundColor: `${brandColor}` || "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: { xs: 2, md: "1.5vw" },
                }}
              >
                <LockOutlinedIcon
                  sx={{
                    color: "white",
                    fontSize: {
                      xs: 25,
                      sm: 30,
                      md: "2.5vw",
                      lg: "2.2vw",
                      xl: "3vw",
                    },
                    minWidth: "25px",
                    // maxWidth: "50px",
                  }}
                />
              </Box>
              <Typography
                variant="h5"
                component="h1"
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  marginBottom: 1,
                  fontSize: {
                    xs: "1.25rem",
                    sm: "1.5rem",
                    md: "1.75rem",
                    lg: "2vw",
                    xl: "1.8vw",
                  },
                }}
              >
                Client Verification
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  textAlign: "center",
                  fontSize: {
                    xs: "0.875rem",
                    sm: "1rem",
                    md: "1.125rem",
                    lg: "1.2vw",
                    xl: "1vw",
                  },
                }}
              >
                Enter your PIN to access the system
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                type="password"
                fullWidth
                id="client_pin"
                label="Client PIN"
                placeholder="Enter your PIN"
                value={aiFormData.client_pin || ""}
                onChange={handleManualInputChange}
                onFocus={() => setShowKeyboard(true)}
                required
                inputRef={inputRef}
                inputProps={{
                  maxLength: 4,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                sx={{
                  marginBottom: 2,
                  height: { lg: "1.5vw" },
                  "& .MuiOutlinedInput-root": {
                    fontSize: {
                      xs: "1rem",
                      sm: "1.125rem",
                      md: "1.25rem",
                      lg: "1.3vw",
                      xl: "1.4vw",
                    },
                    "& input": {
                      padding: {
                        xs: "14px 14px",
                        lg: "0.9vw 1vw",
                        xl: "1vw 1.1vw",
                      },
                      letterSpacing: { xs: "6px", lg: "0.6rem", xl: "1.2rem" },
                      "&::placeholder": {
                        letterSpacing: "normal",
                        opacity: 0.6,
                      },
                    },
                    "& fieldset": {
                      transition: "border-color 0.2s ease-in-out",
                    },
                    "&:hover fieldset": {
                      borderColor: "#667eea",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#667eea",
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: "#666",
                    transformOrigin: "left center",
                    fontSize: {
                      xs: "1rem",
                      sm: "1.125rem",
                      md: "1.25rem",
                      lg: "1.2vw",
                      xl: "1.4vw",
                    },
                    transition:
                      "color 0.2s ease-in-out, transform 0.25s ease-in-out, font-size 0.2s ease",
                  },

                  "& .MuiInputLabel-shrink": {
                    color: "#667eea",
                    transformOrigin: "left top",
                    transform: {
                      xl: "translate(0.6vw, -0.9vw) scale(0.75)",
                    },
                  },

                  "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
                    color: "#667eea",
                    transform: {
                      xs: "translate(14px, 16px) scale(1)",
                      lg: "translate(1vw, 1vw) scale(1)",
                      xl: "translate(1.1vw, 0.9vw) scale(1)",
                    },
                  },
                }}
              />

              {/* Virtual Keyboard */}
              {showKeyboard && (
                <Box sx={{ marginBottom: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: { xs: 0.75, sm: 1, md: 1.25, lg: "0.8vw" },
                      padding: { xs: 1.5, sm: 2, md: 2.5, lg: "0.5vw" },
                      paddingTop: { lg: "4.5vw" },
                      paddingBottom: { lg: "2vw" },
                      backgroundColor: "#f8f9fa",
                      borderRadius: 2,
                    }}
                  >
                    {keys.map((row, rowIndex) => (
                      <Box
                        key={rowIndex}
                        sx={{
                          display: "flex",
                          gap: { xs: 0.75, sm: 1, md: 1.25, lg: "0.8vw" },
                          justifyContent: "center",
                        }}
                      >
                        {row.map((key) => {
                          const isDisabled =
                            key !== "⌫" &&
                            key !== "Enter" &&
                            (aiFormData.client_pin || "").length >= 4;

                          return (
                            <Button
                              key={key}
                              type="button"
                              onClick={() => !isDisabled && handleKeyPress(key)}
                              disabled={isDisabled}
                              sx={{
                                flex: 1,
                                padding: {
                                  xs: "12px",
                                  sm: "16px",
                                  md: "20px",
                                  lg: "1.5vw",
                                  xl: "1.3vw",
                                },
                                fontSize: {
                                  xs: "1rem",
                                  sm: "1.125rem",
                                  md: "1.25rem",
                                  lg: "1.5vw",
                                  xl: "1.3vw",
                                },
                                fontWeight: 500,
                                border: "1px solid #ddd",
                                borderRadius: 2,
                                backgroundColor:
                                  key === "Enter"
                                    ? brandColor
                                    : key === "⌫"
                                    ? "#ff6b6b"
                                    : isDisabled
                                    ? "#e0e0e0"
                                    : "#fff",
                                color:
                                  key === "Enter" || key === "⌫"
                                    ? "white"
                                    : isDisabled
                                    ? "#9e9e9e"
                                    : "#333",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                transition: "all 0.2s",
                                minWidth: {
                                  xs: key === "Enter" ? "60px" : "50px",
                                  sm: key === "Enter" ? "80px" : "60px",
                                  md: key === "Enter" ? "100px" : "80px",
                                  lg: key === "Enter" ? "8vw" : "6vw",
                                  xl: key === "Enter" ? "7vw" : "5.5vw",
                                },
                                minHeight: {
                                  xs: "48px",
                                  sm: "56px",
                                  md: "64px",
                                  lg: "4.5vw",
                                  xl: "4vw",
                                },
                                "&:hover": !isDisabled
                                  ? {
                                      backgroundColor:
                                        key === "Enter"
                                          ? brandColor
                                          : key === "⌫"
                                          ? "#ff6b6b"
                                          : "#f0f0f0",
                                      transform: "translateY(-1px)",
                                      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                    }
                                  : {},
                                "&:active": !isDisabled
                                  ? {
                                      transform: "scale(0.95)",
                                    }
                                  : {},
                              }}
                            >
                              {key}
                            </Button>
                          );
                        })}
                      </Box>
                    ))}
                  </Box>
                  <Button
                    type="button"
                    onClick={() => setShowKeyboard(false)}
                    sx={{
                      marginTop: { lg: "1vw" , xl: "1.5vw" },
                      marginBottom: { lg: "1vw" , xl: "1.5vw" },
                      padding: "0.5rem 1rem",
                      fontSize: {
                        xs: "0.75rem",
                        sm: "0.875rem",
                        md: "1rem",
                        lg: "1vw",
                        xl: "0.9vw",
                      },
                      background: "none",
                      border: "none",
                      color: "#666",
                      cursor: "pointer",
                      textDecoration: "underline",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "#333",
                      },
                    }}
                  >
                    Hide Keyboard
                  </Button>
                </Box>
              )}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={(aiFormData.client_pin || "").length !== 4}
                sx={{
                  mt: {
                    lg: `${showKeyboard ? "1vw" : "3vw"}`,
                    xl: `${showKeyboard ? "1vw" : "4vw"}`,
                  },
                  mb: 1,
                  py: { xs: 1.25, sm: 1.5, md: 1.75, lg: "1.4vw", xl: "2vw" },
                  fontSize: {
                    xs: "0.875rem",
                    sm: "1rem",
                    md: "1.125rem",
                    lg: "1.3vw",
                    xl: "1.1vw",
                  },
                  fontWeight: 600,
                  textTransform: "none",
                  backgroundColor:
                    (aiFormData.client_pin || "").length === 4
                      ? `${brandColor}` || "#000"
                      : "#ccc",
                  boxShadow:
                    (aiFormData.client_pin || "").length === 4
                      ? "0 4px 15px rgba(102, 126, 234, 0.4)"
                      : "none",
                  "&:hover":
                    (aiFormData.client_pin || "").length === 4
                      ? {
                          backgroundColor: `${brandColor}` || "#000",
                          boxShadow: "0 6px 20px rgba(102, 126, 234, 0.5)",
                          transform: "translateY(-2px)",
                        }
                      : {},
                }}
              >
                Verify & Continue
              </Button>
            </form>
          </Paper>

          {/*<Typography
            variant="caption"
            sx={{
              display: "block",
              textAlign: "center",
              color: "#999",
              marginTop: { xs: 2, sm: 3 },
              fontSize: {
                xs: "0.75rem",
                sm: "0.875rem",
                md: "1rem",
                lg: "1vw",
                xl: "0.85vw",
              },
            }}
          >
            Protected by secure authentication
          </Typography> */}
        </Box>
      </Box>
    );
  }
}